module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spec-line-robot"
  }, [_c('div', {
    staticClass: "align-c btn-rows"
  }, [_vm._l((_vm.suggestions), function(sug, sug_i) {
    return (_vm.sug_index == undefined) ? [_c('btn', {
      attrs: {
        "color": "secondary"
      },
      nativeOn: {
        "click": function($event) {
          _vm.sug_index = sug_i
        }
      }
    }, [_vm._v(_vm._s(sug.title))]), _vm._v(" \n\t\t")] : _vm._e()
  })], 2), _vm._v(" "), (_vm.sug_index != undefined) ? [_c('div', {
    staticClass: "align-c btn-rows"
  }, [_c('btn', {
    attrs: {
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.sug_index = undefined
      }
    }
  }, [_vm._v("← Tilbage")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.suggestions[_vm.sug_index].entries), function(entry, entry_i) {
    return [_c('btn', {
      attrs: {
        "icon-r": "+"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.selectEntry(entry)
        },
        "mouseover": function($event) {
          _vm.preview = entry
        },
        "mouseout": function($event) {
          _vm.preview = undefined
        }
      }
    }, [_vm._v(_vm._s(entry.title))]), _vm._v(" \n\t\t\t")]
  })], 2)] : _vm._e(), _vm._v(" "), (_vm.sug_index != undefined && _vm.preview) ? _c('div', {
    staticClass: "preview"
  }, [(_vm.preview) ? [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.preview.line.title) + " — " + _vm._s(_vm.preview.line.hours) + " timer")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.preview.line.text))])] : _vm._e()], 2) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46a8f8f3","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SpecLineRobot.vue
// module id = 600
// module chunks = 1